import { NS_CONFIGURATION, SPRINT, FIELDSET } from 'redux/constants';
import { action, createType, SYNC, ASYNC } from 'redux-create-type';
import {createSetCostOfEstimationActions} from '../../../../helpers';

export const {
  INIT,
  SET_TAB,
  SET_WEEK,
  SET_USER_DAY,
  SET_NAME,
  SET_CAPACITY,
  SET_HOUR_CAPACITY,
  RESET,
  SET_START_DATE,
  SET_END_DATE,
  MEMBERS_UPDATED,
  RESET_CHANGES,
  SET_COST_OF_ESTIMATION,
  SET_COST_OF_ESTIMATION_INHERIT,
  SET_WORKING_DURATION,
  RECALCULATE_HOURS,
  RECALCULATE_SP,
  RECALCULATE_RECOMMENDED_CAPACITY,
  REMOVE,
} = createType(NS_CONFIGURATION, SPRINT, FIELDSET)({
    INIT: ASYNC,
    SET_TAB: SYNC,
    SET_WEEK: SYNC,
    SET_USER_DAY: ASYNC,
    SET_NAME: SYNC,
    SET_CAPACITY: SYNC,
    SET_HOUR_CAPACITY: SYNC,
    RESET: SYNC,
    SET_START_DATE: SYNC,
    SET_END_DATE: SYNC,
    MEMBERS_UPDATED: SYNC,
    RESET_CHANGES: SYNC,
    SET_COST_OF_ESTIMATION: ASYNC,
    SET_COST_OF_ESTIMATION_INHERIT: ASYNC,
    SET_WORKING_DURATION: ASYNC,
    RECALCULATE_HOURS: ASYNC,
    RECALCULATE_SP: ASYNC,
    RECALCULATE_RECOMMENDED_CAPACITY: SYNC,
    REMOVE: SYNC
});


export const init = {
  begin: ({ sprint }) => action(INIT.BEGIN, { sprint }),
  end: ({
    teamOptions,
    selectedTeam,
    weekOptions,
    dayOverridesHash,
    costOfEstimationModel,
   }) => action(INIT.END, {
      teamOptions,
      selectedTeam,
      weekOptions,
      dayOverridesHash,
      costOfEstimationModel
    }),
};
export const setTab = value => action(SET_TAB, { value });
export const setWeek = value => action(SET_WEEK, { value });
export const setUserDay = {
  begin: ({ user, day }) => action(SET_USER_DAY.BEGIN, { user, day }),
  end: ({ dayOverridesHash, user }) => action(SET_USER_DAY.END, { dayOverridesHash, user }),
};
export const setName = value => action(SET_NAME, { value });
export const setCapacity = value => action(SET_CAPACITY, { value });
export const setHourCapacity = value => action(SET_HOUR_CAPACITY, { value });
export const reset = () => action(RESET);
export const setStartDate = value => action(SET_START_DATE, { value });
export const setEndDate = value => action(SET_END_DATE, { value });
export const membersUpdated = ({
  users,
  sprintLenght,
  workingDuration,
  weekOptions,
  dayOverridesHash
 }) => action(MEMBERS_UPDATED, {
    users,
    sprintLenght,
    workingDuration,
    weekOptions,
    dayOverridesHash
  });

export const resetChanges = () => action(RESET_CHANGES);
export const setCostOfEstimation = createSetCostOfEstimationActions(SET_COST_OF_ESTIMATION);
export const setCostInherit = {
  begin: ({ costOfEstUnitInherit }) => action(SET_COST_OF_ESTIMATION_INHERIT.BEGIN, { costOfEstUnitInherit }),
  end: ({ costOfEstimationModel, costOfEstUnitInherit }) => action(SET_COST_OF_ESTIMATION_INHERIT.END, {
      costOfEstimationModel, costOfEstUnitInherit })
};
export const setWorkingDuration = {
  begin: ({ user }) => action(SET_WORKING_DURATION.BEGIN, { user }),
  end: ({ user }) => action(SET_WORKING_DURATION.END, { user }),
};
export const recalculateHours = {
  begin: ({ user }) => action(RECALCULATE_HOURS.BEGIN, { user }),
  end: ({ user }) => action(RECALCULATE_HOURS.END, { user }),
};
export const recalculateSp = {
  begin: ({ user }) => action(RECALCULATE_SP.BEGIN, { user }),
  end: ({ user }) => action(RECALCULATE_SP.END, { user }),
};
export const recalculateRecommendedCapacity = () => action(RECALCULATE_RECOMMENDED_CAPACITY);
export const remove = () => action(REMOVE);



// WEBPACK FOOTER //
// ../redux/store/configuration/sprint/fieldset/actions.js